/**
 * Spacing Tokens - Base spacing scale and layout spacing
 */

export const spacing = {
  0: { value: '0px' },
  '3xs': { value: '2px' },
  '2xs': { value: '4px' },
  xs: { value: '8px' },
  s: { value: '12px' },
  m: { value: '16px' },
  l: { value: '20px' },
  xl: { value: '24px' },
  '2xl': { value: '28px' },
  '3xl': { value: '32px' },
  '4xl': { value: '40px' },
  '5xl': { value: '48px' },
  layoutMargin: {
    s: { value: '16px' },
    m: { value: '24px' },
    l: { value: '32px' },
  },
  layoutGutter: {
    s: { value: '16px' },
  },
};
